module.exports = __webpack_public_path__ + "static/media/lock-icon.ad6b4932.svg";